import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AcademyHighlightService } from 'src/app/services/academy-highlight.service';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { TitleCasePipe } from '@angular/common';
@Component({
  selector: 'app-highlights',
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss'],
  providers: [ConfirmationService, MessageService, TitleCasePipe]
})
export class AcademyHighlightsComponent implements OnInit {
  highlightform: FormGroup;
  submitted = false;
  imageSize = environment.imageSize;
  uploadedFiles: any[] = [];
  highlightimage: any;
  isAddMode: boolean = true;
  pagetitle: string;
  public showingForm: boolean = false;
  loggedInAcademy;
  loggedInAcademyId;
  highlightlist: any;
  loading: boolean;
  errorMessage = '';
  defaultvalue;
  item: any;
  highlightid: any;
  public disabled: boolean = false;
  showUploadedpic: boolean = false;
  imagehighlight: any;
  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private highlightservice: AcademyHighlightService,
    private messageService: MessageService,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private confirmationService: ConfirmationService,
    private titlecasePipe: TitleCasePipe
  ) { }

  ngOnInit(): void {
    this.loggedInAcademy = this.tokenStorage.getUser();
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'created') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    }
    this.highlightform = this.formBuilder.group({
      heading: ['', [Validators.required, Validators.pattern("([a-zA-Z',.-_&]+( [a-zA-Z',.-_&]+)*){2,30}")]],
      //url: ['', [Validators.required, Validators.pattern("^((ftp|http|https):\/\/)?(w)?(ww)?(?!.*(ftp|http|https|www|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?\/?$")]],
      descriptions: [''],
    }, { updateOn: "blur" });
    this.loadhightlightlist();
  }
  get f() {
    return this.highlightform.controls;
  }
  openmodal() {
    this.highlightform.reset();
    this.pagetitle = 'Add WOW FACTOR / ACHIEVEMENTS';
    this.uploadedFiles = [];
    this.highlightimage = '';
    this.isAddMode = true;
    this.showingForm = true;

  }
  onHighlightModalClose() {
    this.highlightform.reset();
    this.showingForm = false;
  }
  onClickEdit(id) {
    this.isAddMode = false;
    this.pagetitle = 'Edit WOW FACTOR / ACHIEVEMENTS';
    this.showingForm = true;
    this.gethighlightdetails(id);
  }
  gethighlightdetails(id) {
    this.highlightservice.getAcademyHighlightDetails(id).subscribe(res => {
      this.item = res;
      this.highlightid = id;
      this.highlightform.controls.heading.setValue(this.item.heading);
      //this.highlightform.controls.url.setValue(this.item.url);
      this.highlightform.controls.descriptions.setValue(this.item.descriptions);
      if (this.item['image'] != undefined) {
        this.imagehighlight = this.item['image'];
        this.showUploadedpic = true;
      } else {
        this.showUploadedpic = false;
      }
    })
  }
  loadhightlightlist() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.highlightservice.getAcademyHighlightList(query).subscribe(
      data => {
        this.loading = false;
        this.highlightlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  picUploader(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result != null) {
          this.highlightimage = reader.result;
        }
      }
    }
  }
  onsubmit() {
    this.submitted = true;
    if (this.highlightform.invalid) {
      return;
    }
    var highlightData = this.highlightform.value;
    highlightData['academyId'] = this.loggedInAcademyId;
    highlightData['status'] = true;
    highlightData['disable'] = false
    if (this.isAddMode) {
      highlightData['image'] = this.highlightimage;
      highlightData = JSON.stringify(highlightData, null, 4);
      this.addHighlight(highlightData);
    } else {
      highlightData['image'] = this.highlightimage;
      highlightData = JSON.stringify(highlightData, null, 4);
      this.updateHighlight(highlightData);

    }
  }
  addHighlight(highlightData) {
    this.highlightservice.addAcademyHighlight(highlightData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Wow Factor/ Achievements Added', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/academies-profile/highlights']);
        }, 2000);
        this.uploadedFiles = [];
        this.highlightimage = '';
        this.onHighlightModalClose();
        this.loadhightlightlist();
        this.highlightform.reset();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Wow Factor/ Achievements failed', life: 6000 });
        this.onHighlightModalClose();
        this.highlightform.reset();
      })
    );
  }
  updateHighlight(highlightData) {
    this.highlightservice.updateAcademyHighlight(this.highlightid, highlightData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Wow Factor/ Achievements Updated', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/academies-profile/highlights']);
        }, 2000);
        this.onHighlightModalClose();
        this.highlightform.reset();
        this.loadhightlightlist();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Wow Factor/ Achievements failed', life: 6000 });
        this.onHighlightModalClose();
        this.highlightform.reset();
      })
    );
  }


  onClickDelete(data) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this Wow Factor / Achievements?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let disableStatus;
        if (data.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        let updatedata = '{"disable":' + disableStatus + '}';
        this.highlightservice.updateAcademyHighlight(data.id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Wow Factor/ Achievements Deleted', life: 3000 });
            this.loadhightlightlist();
          },
          err => {
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'System Error. Please try again.', life: 3000 });
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }

  public onIndexChange(index: number): void {
    //console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    //console.log('Swiper event: ', event);
  }

  public toggleKeyboardControl(): void {
    this.court_config.keyboard = !this.court_config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.court_config.mousewheel = !this.court_config.mousewheel;
  }


}
